import {
  type Action,
  type ControlType,
  TrackObject,
  useAnalyticsTracker,
} from "./AnalyticsProvider";

type BaseGamePageExtras = {
  id: string;
  gameId?: string;
  gameName?: string;
  imageIndex?: string;
  questId?: string;
  version?: string;
  controlLabel?: string;
};

type GamePageViewedEvent = {
  action: Action.VIEWED;
  extras: BaseGamePageExtras;
};

type GamePagePressedEvent = {
  action: Action.PRESSED;
  extras: BaseGamePageExtras & {
    control: string;
    controlType: ControlType;
  };
};

type GamePageHoverEvent = {
  action: Action.HOVER;
  extras: BaseGamePageExtras & {
    control: string;
    controlType: ControlType;
  };
};

type GamePageSucceededEvent = {
  action: Action.SUCCEEDED;
  extras: BaseGamePageExtras;
};

type GamePageFailedEvent = {
  action: Action.FAILED;
  extras: BaseGamePageExtras;
};

export type GamePageEvent =
  | GamePageViewedEvent
  | GamePagePressedEvent
  | GamePageHoverEvent
  | GamePageSucceededEvent
  | GamePageFailedEvent;

export const useGamePageAnalytics = () =>
  useAnalyticsTracker<GamePageEvent>(TrackObject.GAME_PAGE);
